import {
  configured_engagement_drawer,
  engagement_row_by_code,
  fallback_engagement_drawer
} from './audit_drawer_helpers';

export const finding_drawer_catalog = {
  'AFS-2026-001': {
    title: 'RFQ evaluation records not retained for two awards',
    subtitle: 'AUD-01 - AGSA regular audit - FY2025/26 - owner SCM Manager - T. Mbatha',
    alert: 'Recent two FY2024/25 SCM finding - AGSA weighs repeat findings heavily. Root cause must be addressed, not just symptoms.',
    lifecycle: ['Open', 'Management response', 'In progress', 'Internal audit review', 'Resolved'],
    copy: 'For two competitive procurements above the quotation threshold, the evaluation and award records could not be produced, constituting irregular expenditure under the PFMA and SCM regulation.',
    criteria: 'PFMA s.38(1)(a)(iii); SCM Regulation; National Treasury Practice Note on record-keeping',
    root_cause: 'Evaluation file kept locally by buyer; no central, indexed evidence repository.',
    effect: 'Irregular expenditure / R2.4m; audit qualification risk on SCM. Controls are visible, but absence of records makes awards and links to each award before payment.',
    recommendation: 'Centralise all evaluation records in a controlled audit file and enforce submission before payment.',
    management_response: 'Accepted. All evaluation records will be uploaded to the evidence vault and the payment gate will require a linked award file. Accountable: Accounting Officer - due 30 Jun 2026',
    connected_records: [['Procurement', 'RFQ-089 / RFQ-091'], ['Finance', 'Irregular expenditure register'], ['Supplier', 'T. Mbatha'], ['Control', 'C-110'], ['Bid declarations', 'Bid committee declarations'], ['Corrective action', 'CA-001'], ['Report', 'Board audit pack'], ['Evidence vault', 'Bid evaluation pack']],
    action_plan: [['Recover and index the two missing evaluation files', 'SCM - due 31 May 2026', 'In progress'], ['Configure payment gate to require linked award record', 'Finance - due 15 Jun 2026', 'Not started'], ['Report irregular expenditure to Accounting Office if not recovered in time', 'CFO - due 30 Jun 2026', 'In progress']],
    submissions: [['RFQ-089 evaluation file (recovered)', 'Document - SCM - 20 May 2026', 'Submitted']],
    review_owner: 'Chief Audit Executive',
    review_status: 'Pending',
    review_actions: ['Clear & close', 'Send back']
  },
  'AFS-2026-002': {
    title: 'Privileged access not reviewed for April',
    subtitle: 'AUD-01 - AGSA regular audit - FY2025/26 - owner CISO - R. Govender',
    lifecycle: ['Open', 'Management response', 'In progress', 'Internal audit review', 'Resolved', 'Closed'],
    copy: 'The monthly privileged-access review was not performed for April 2026, weakening control over administrative access to financial systems.',
    criteria: 'Information security policy; AGSA IT general-controls framework; Treasury IT governance.',
    root_cause: 'Manual process with no enforced reminder; reviewer on leave with no delegate.',
    effect: 'Risk of undetected unauthorised access and changes to financial data.',
    recommendation: 'Automate monthly access-review reminder and assign a standing delegate.',
    management_response: 'Accepted. April review completed; automated reminders being implemented. Due: 30 Jun 2026',
    connected_records: [['Control', 'C-122'], ['File', 'IR-03'], ['Incident', 'INC-2026-014'], ['Corrective action', 'CA-003'], ['Evidence vault', 'Access review export']],
    action_plan: [['Complete April privileged-access review', 'IT Security - due 10 May 2026', 'Implemented'], ['Automate monthly review reminders + delegate', 'IT Security - due 20 Jun 2026', 'In progress']],
    submissions: [['April access review report', 'Audit - IT Security - 19 May 2026', 'Submitted']],
    review_owner: 'Chief Audit Executive',
    review_status: 'Pending',
    review_actions: ['Clear & close', 'Send back']
  },
  'AFS-2026-004': {
    title: 'Performance information not supported by evidence',
    subtitle: 'AUD-01 - AGSA regular audit - FY2025/26 - owner Strategy & M&E - L. Adams',
    lifecycle: ['Open', 'Management response', 'In progress', 'Internal audit review', 'Resolved', 'Closed'],
    copy: 'Reported achievements for two performance indicators were not supported by a verifiable portfolio of evidence.',
    criteria: 'Framework for Managing Programme Performance Information (FMPPI); AGSA POE methodology',
    root_cause: 'Evidence collected at year-end rather than continuously.',
    effect: 'Risk of qualified audit on predetermined objectives.',
    recommendation: 'Maintain a live portfolio of evidence per indicator throughout the year.',
    management_response: 'No management response captured - required before action plan.',
    connected_records: [['Evidence vault', 'Performance portfolio']],
    action_plan: [],
    submissions: [],
    review_owner: 'Chief Audit Executive',
    review_status: 'Pending',
    review_actions: ['Clear & close', 'Send back']
  },
  'AFS-2026-006': {
    title: 'Operator processing personal data without signed DPA',
    subtitle: 'AUD-03 - POPIA & IT general controls review - owner Information Officer - P. Naidoo',
    lifecycle: ['Open', 'Management response', 'In progress', 'Internal audit review', 'Resolved', 'Closed'],
    copy: 'A third-party operator was processing personal information without a signed data-processing agreement.',
    criteria: 'POPIA ss.20-21; information security policy.',
    root_cause: 'Operator onboarded before DPA execution; no gate enforcing legal review.',
    effect: 'Unlawful processing; POPIA breach and regulator exposure.',
    recommendation: 'Suspend data sharing until a DPA is signed, enforce a DPA gate at supplier onboarding.',
    management_response: 'No management response captured - required before action plan.',
    connected_records: [['Supplier', 'BlueData Services'], ['Contract', 'K-105'], ['Control', 'C-216'], ['POPIA policy', 'POPIA policy'], ['RFI', 'R-42'], ['Corrective action', 'CA-004'], ['Evidence vault', 'DPA repository']],
    action_plan: [],
    submissions: [],
    review_owner: 'Chief Audit Executive',
    review_status: 'Pending',
    review_actions: ['Clear & close', 'Send back']
  },
  'AFS-2026-003': {
    title: 'Supplier paid with expired tax clearance (blocked)',
    subtitle: 'AUD-01 - AGSA regular audit - FY2025/26 - owner Procurement - T. Mbatha',
    alert: 'Recent two FY2024/25 SCM finding - AGSA weighs repeat findings heavily. Root cause must be addressed, not just symptoms.',
    lifecycle: ['Open', 'Management response', 'In progress', 'Internal audit review', 'Resolved'],
    copy: 'A payment to a supplier with an expired tax clearance was attempted; the control correctly blocked it, but the supplier profile on the master file.',
    criteria: 'Tax Administration Act; SCM regulations; payment policy',
    root_cause: 'Supplier master not synchronised with documents-expiry monitoring.',
    effect: 'Near-miss irregular payment; control effective but master-data gap.',
    recommendation: 'Auto-flag and suspend suppliers on document expiry; issue an automated reminder.',
    management_response: 'Accepted. Supplier suspended; CIPC/tax/status revalidation triggered. Accountable: CFO - due 15 Jun 2026',
    connected_records: [['Finance', 'INV-2219'], ['Supplier', 'ABC Tech Solutions'], ['Control', 'C-101'], ['Corrective action', 'CA-002'], ['Evidence vault', 'Tax clearance - ABC Tech']],
    action_plan: [['Suspend supplier and request fresh tax clearance', 'Procurement - due 11 May 2026', 'Implemented'], ['Sync supplier master with expiry monitoring', 'SCM System - due 15 Jun 2026', 'In progress']],
    submissions: [['Suspension confirmation', 'Approval - Procurement - 16 May 2026', 'Submitted'], ['OnboardOS revalidation request', 'Log - Procurement - 19 May 2026', 'Submitted']],
    review_owner: 'Chief Audit Executive',
    review_status: 'Cleared',
    review_actions: ['Clear & close', 'Send back']
  },
  'AFS-2026-005': {
    title: 'Conflict-of-interest declaration outstanding for bid member',
    subtitle: 'AUD-01 - AGSA regular audit - FY2025/26 - owner HR - N. Dlamini',
    lifecycle: ['Open', 'Management response', 'In progress', 'Internal audit review', 'Resolved', 'Closed'],
    copy: 'One bid-evaluation committee member had not submitted a current conflict-of-interest declaration at the time of award.',
    criteria: 'SCM regulation; Code of conduct; ethics policy',
    root_cause: 'No system block preventing participation without a current declaration.',
    effect: 'Risk of undisclosed conflict influencing an award.',
    recommendation: 'Block committee participation until a current declaration is on file.',
    management_response: 'Accepted. Declarations obtained; system control being added. Resolved: SCM Manager - due 30 Jun 2026',
    connected_records: [['Procurement', 'Bid committee'], ['Control', 'C-205'], ['Policy', 'Code of conduct'], ['Conflict declarations', 'COI-09 / bid committee']],
    action_plan: [['Obtain outstanding declaration', 'HR - due 28 May 2026', 'Implemented'], ['Add system block to committee workflow', 'SCM System - due 20 Jun 2026', 'Not started']],
    submissions: [],
    review_owner: 'Chief Audit Executive',
    review_status: 'Pending',
    review_actions: ['Clear & close', 'Send back']
  }
};

export const engagement_drawer_catalog = {
  'AUD-01': {
    subtitle: 'Auditor-General of South Africa - FY2025/26',
    prior_outcome: 'Unqualified with findings',
    target: 'Clean audit',
    fieldwork: '01 Jun - 31 Aug 2026',
    scope: ['Supply chain management & procurement', 'Annual financial statements (PFMA)', 'Predetermined objectives / performance information', 'Compliance with key legislation', 'Consequence management', 'Information systems (general controls)'],
    findings: ['AFS-2026-001', 'AFS-2026-002', 'AFS-2026-003', 'AFS-2026-004', 'AFS-2026-005']
  },
  'AUD-02': {
    subtitle: 'Internal Audit Unit - Q2 FY2025/26',
    prior_outcome: '-',
    target: 'Assurance to Audit Committee',
    fieldwork: '14 Apr - 02 May 2026',
    scope: ['Three-quote & bid compliance', 'Deviation & expansion approvals', 'Supplier document validity', 'Conflict-of-interest declarations'],
    findings: []
  },
  'AUD-03': {
    subtitle: 'Internal Audit + co-source - Q3 FY2025/26',
    prior_outcome: '-',
    target: 'Assurance to Audit Committee',
    fieldwork: 'Planned - Sep 2026',
    scope: ['Privileged access reviews', 'Operator / DPA register', 'Backup & recovery', 'Change management'],
    findings: ['AFS-2026-006']
  }
};

export const audit_pack_catalog = {
  'AUD-01': {
    sections: [
      { title: 'Audit plan and scope', note: '6 scope areas defined', state: 'Ready', state_class: 'bg-success-subtle text-success-emphasis', icon: 'bi-check2-square' },
      { title: 'Finding register and ratings', note: '5 findings - 3 material/significant', state: 'Ready', state_class: 'bg-success-subtle text-success-emphasis', icon: 'bi-check2-square' },
      { title: 'Management action plans', note: '9 actions across findings', state: 'Gap', state_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-exclamation-circle' },
      { title: 'Evidence submissions', note: '1 of 5 RFIs accepted', state: 'Gap', state_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-exclamation-circle' },
      { title: 'Internal audit review sign-off', note: '1 findings cleared', state: 'Gap', state_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-exclamation-circle' },
      { title: 'Repeat-finding analysis', note: '2 repeat findings flagged', state: 'Ready', state_class: 'bg-success-subtle text-success-emphasis', icon: 'bi-check2-square' }
    ],
    scope_rows: [
      { area: 'Supply chain management', readiness: 62, findings: 5, owner: 'SCM Manager', evidence: 'Missing evidence', evidence_class: 'bg-danger-subtle text-danger-emphasis' },
      { area: 'Annual financial statements', readiness: 76, findings: 3, owner: 'CFO', evidence: 'Action needed', evidence_class: 'bg-warning-subtle text-warning-emphasis' },
      { area: 'Predetermined objectives', readiness: 73, findings: 2, owner: 'Strategy and M&E', evidence: 'Register update due', evidence_class: 'bg-warning-subtle text-warning-emphasis' },
      { area: 'Compliance with legislation', readiness: 68, findings: 4, owner: 'Compliance Officer', evidence: 'Action needed', evidence_class: 'bg-warning-subtle text-warning-emphasis' },
      { area: 'Consequence management', readiness: 70, findings: 2, owner: 'Accounting Officer', evidence: 'Action needed', evidence_class: 'bg-warning-subtle text-warning-emphasis' },
      { area: 'IT general controls', readiness: 69, findings: 4, owner: 'CISO', evidence: 'Access review overdue', evidence_class: 'bg-warning-subtle text-warning-emphasis' }
    ]
  },
  'AUD-02': {
    sections: [
      { title: 'Audit plan and scope', note: '4 procurement controls in scope', state: 'Ready', state_class: 'bg-success-subtle text-success-emphasis', icon: 'bi-check2-square' },
      { title: 'Finding register and ratings', note: 'No live findings in this cycle', state: 'Ready', state_class: 'bg-success-subtle text-success-emphasis', icon: 'bi-check2-square' },
      { title: 'Management action plans', note: 'No outstanding remediation items', state: 'Ready', state_class: 'bg-success-subtle text-success-emphasis', icon: 'bi-check2-square' },
      { title: 'Evidence submissions', note: 'Core SCM evidence accepted', state: 'Ready', state_class: 'bg-success-subtle text-success-emphasis', icon: 'bi-check2-square' },
      { title: 'Internal audit review sign-off', note: 'Reporting pack prepared for committee', state: 'Ready', state_class: 'bg-success-subtle text-success-emphasis', icon: 'bi-check2-square' },
      { title: 'Repeat-finding analysis', note: 'One historic issue monitored', state: 'Gap', state_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-exclamation-circle' }
    ],
    scope_rows: [
      { area: 'Three-quote compliance', readiness: 88, findings: 0, owner: 'SCM Manager', evidence: 'Evidence complete', evidence_class: 'bg-success-subtle text-success-emphasis' },
      { area: 'Deviation approvals', readiness: 84, findings: 0, owner: 'Accounting Officer', evidence: 'Evidence complete', evidence_class: 'bg-success-subtle text-success-emphasis' },
      { area: 'Supplier document validity', readiness: 79, findings: 1, owner: 'Procurement', evidence: 'Monitor follow-up', evidence_class: 'bg-warning-subtle text-warning-emphasis' },
      { area: 'Conflict declarations', readiness: 82, findings: 1, owner: 'HR', evidence: 'Evidence complete', evidence_class: 'bg-success-subtle text-success-emphasis' }
    ]
  },
  'AUD-03': {
    sections: [
      { title: 'Audit plan and scope', note: 'Planning pack drafted for September fieldwork', state: 'Ready', state_class: 'bg-success-subtle text-success-emphasis', icon: 'bi-check2-square' },
      { title: 'Finding register and ratings', note: '1 open compliance issue linked', state: 'Gap', state_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-exclamation-circle' },
      { title: 'Management action plans', note: 'Response still required from Information Officer', state: 'Gap', state_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-exclamation-circle' },
      { title: 'Evidence submissions', note: 'DPA repository still incomplete', state: 'Gap', state_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-exclamation-circle' },
      { title: 'Internal audit review sign-off', note: 'Planning review pending', state: 'Gap', state_class: 'bg-warning-subtle text-warning-emphasis', icon: 'bi-exclamation-circle' },
      { title: 'Repeat-finding analysis', note: 'No repeat issues flagged yet', state: 'Ready', state_class: 'bg-success-subtle text-success-emphasis', icon: 'bi-check2-square' }
    ],
    scope_rows: [
      { area: 'Privileged access reviews', readiness: 69, findings: 1, owner: 'CISO', evidence: 'Access review overdue', evidence_class: 'bg-warning-subtle text-warning-emphasis' },
      { area: 'Operator / DPA register', readiness: 42, findings: 1, owner: 'Information Officer', evidence: 'Missing signed DPA', evidence_class: 'bg-danger-subtle text-danger-emphasis' },
      { area: 'Backup and recovery', readiness: 63, findings: 0, owner: 'IT Operations', evidence: 'Evidence request open', evidence_class: 'bg-warning-subtle text-warning-emphasis' },
      { area: 'Change management', readiness: 58, findings: 0, owner: 'IT Governance', evidence: 'Walkthrough required', evidence_class: 'bg-warning-subtle text-warning-emphasis' }
    ]
  }
};

export const drawer_computed = {
  active_engagement_drawer_data() {
    if (!this.active_engagement_drawer) return null;
    const engagement = engagement_row_by_code(this.engagements, this.active_engagement_drawer);
    if (!engagement) return null;

    const configured = Reflect.get(this.engagement_drawer_catalog, engagement.code);
    if (configured) return configured_engagement_drawer(configured, engagement, this.findings_rows);
    return fallback_engagement_drawer(engagement);
  },
  active_finding_drawer_data() {
    if (!this.active_finding_drawer) return null;
    const row = this.findings_rows.find((item) => item.ref === this.active_finding_drawer);
    if (!row) return null;
    const extra = Reflect.get(this.finding_drawer_catalog, row.ref) || {};
    const merged_row = {
      ...row,
      ...extra
    };

    return merged_row;
  }
};

export const drawer_methods = {
  open_finding_drawer(ref) {
    this.active_finding_drawer = ref;
    document.body.classList.add('audit-drawer-open');
  },
  close_finding_drawer() {
    this.active_finding_drawer = null;
    document.body.classList.remove('audit-drawer-open');
  },
  open_engagement_drawer(code) {
    this.active_engagement_drawer = code;
    document.body.classList.add('audit-drawer-open');
  },
  close_engagement_drawer() {
    this.active_engagement_drawer = null;
    document.body.classList.remove('audit-drawer-open');
  },
  engagement_stage_badge_class(stage) {
    if (stage === 'Fieldwork') return 'bg-warning-subtle text-warning-emphasis';
    if (stage === 'Reporting') return 'bg-success-subtle text-success-emphasis';
    if (stage === 'Planning') return 'bg-light text-secondary';
    return 'bg-info-subtle text-info-emphasis';
  },
  engagement_finding_marker_class(rating) {
    if (rating === 'Material' || rating === 'Moderate') return 'is-material';
    return 'is-significant';
  },
  engagement_finding_marker_label(rating) {
    return rating === 'Material' || rating === 'Moderate' ? 'M' : 'S';
  },
  finding_record_icon(type) {
    const grouped_icon_map = {
      Control: 'bi-shield-check',
      'POPIA policy': 'bi-shield-check',
      Policy: 'bi-shield-check',
      'Evidence vault': 'bi-folder2-open',
      Finance: 'bi-receipt',
      Supplier: 'bi-building',
      Procurement: 'bi-cart3',
      'Corrective action': 'bi-wrench-adjustable-circle',
      'Conflict declarations': 'bi-person-badge',
      Report: 'bi-journal-text',
      Contract: 'bi-file-earmark-text',
      RFI: 'bi-paperclip',
      File: 'bi-paperclip',
      Incident: 'bi-exclamation-triangle'
    };
    return Reflect.get(grouped_icon_map, type) || 'bi-link-45deg';
  },
  finding_action_state_class(state) {
    const state_class_map = {
      Implemented: 'bg-success-subtle text-success-emphasis',
      Submitted: 'bg-success-subtle text-success-emphasis',
      Cleared: 'bg-success-subtle text-success-emphasis',
      'In progress': 'bg-warning-subtle text-warning-emphasis',
      Pending: 'bg-warning-subtle text-warning-emphasis',
      'Not started': 'bg-light text-secondary'
    };
    return Reflect.get(state_class_map, state) || 'bg-info-subtle text-info-emphasis';
  }
};
